import { Fetcher } from "@anivive/utils";

type options = {
  extended: true;
  headers: HeadersInit;
  mode: "cors";
  next: {
    revalidate: number;
  };
  validateStatus: (status: number) => boolean;
};

export const createFetcher = () => {
  const init = async () => {
    const options: Partial<options> = {
      extended: true,
      mode: "cors",
      validateStatus: (status) => [200, 201, 204].includes(status),
    };

    return Fetcher(options);
  };

  return {
    get: <Res>(url: string) => init().then((fetcher) => fetcher.get<Res>(url)),
    post: <Res, Req>(url: string, data: Req) =>
      init().then((fetcher) => fetcher.post<Res>(url, data)),
    patch: <Res, Req>(url: string, data: Req) =>
      init().then((fetcher) => fetcher.patch<Res>(url, data)),
    put: <Res, Req>(url: string, data: Req) =>
      init().then((fetcher) => fetcher.put<Res>(url, data)),
    delete: <Res>(url: string) => init().then((fetcher) => fetcher.delete<Res>(url)),
  };
};
